import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { formsService } from '../api/forms.service';
import { FORM_KEYS } from './queryKeys';

function useFormLifecycleAction(formId: string, action: (formId: string) => Promise<unknown>) {
  const queryClient = useQueryClient();
  const orgId = useOrganizationStore((s) => s.activeOrganizationId);

  return useMutation({
    mutationFn: () => action(formId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: FORM_KEYS.detail(orgId ?? '', formId) });
      queryClient.invalidateQueries({ queryKey: FORM_KEYS.byOrg(orgId ?? '') });
    },
  });
}

export function useCloseForm(formId: string) {
  return useFormLifecycleAction(formId, formsService.close);
}

export function useArchiveForm(formId: string) {
  return useFormLifecycleAction(formId, formsService.archive);
}

export function useDeleteForm(formId: string) {
  return useFormLifecycleAction(formId, formsService.delete);
}
